module.exports = __webpack_public_path__ + "static/media/sax-hot.5efc420c.svg";